module.exports = __webpack_public_path__ + "img/norisk.f7d26a30.png";